import * as R from 'ramda'

const getConversationState = R.propOr({}, 'conversation')

const restoreId = R.pipe(
  getConversationState,
  R.prop('chat_restoreId')
)

const markets = R.pipe(
  getConversationState,
  R.prop('chat_markets')
)

const isChatWidgetShown = R.pipe(
  markets,
  R.length,
  R.lt(0)
)

const isChatWidgetInitiated = R.pipe(
  getConversationState,
  R.prop('chat_initiated')
)

export {
  restoreId,
  markets,
  isChatWidgetShown,
  isChatWidgetInitiated
}
